import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import News from "@/pages/news/page";
import Works from "@/pages/works/page";
import Analysis from "@/pages/analysis/page";
import Culture from "@/pages/culture/page";
import Detail from "@/pages/detail/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/works",
    element: <Works />,
  },
  {
    path: "/analysis",
    element: <Analysis />,
  },
  {
    path: "/culture",
    element: <Culture />,
  },
  {
    path: "/detail/:id",
    element: <Detail />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;